import { Component, OnDestroy, OnInit } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { AlertifyService } from "./_models/alertify.service";
import { environment } from "./../environments/environment";
import { filter, map } from "rxjs/operators";
import { SessionTimeoutService } from "./_common/session-timeout-service";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
export let browserRefresh = false;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  navigationSubscription: any;
  constructor(
    private alertifyService: AlertifyService,
    private swUpdate: SwUpdate,
    private router: Router
  ) {
    this.navigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !this.router.navigated;
      }
    });
  }

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(async (evt) => {
        switch (evt.type) {
          case "VERSION_DETECTED":
            console.log(`Downloading new app version: ${evt.version.hash}`);
            break;
          case "VERSION_READY":
            console.log(
              `New app version ready for use: ${evt.latestVersion.hash}`
            );
            await this.swUpdate.activateUpdate();
            this.alertifyService.confirmOkCancel(
              "Update to the latest version of STP AuditHub",
              "Changes have been made to STP AuditHub. Please update before continuing.",
              () => {
                window.location.reload();
              },
              () => {
                // Cancel
                return false;
              }
            );
            break;
          case "VERSION_INSTALLATION_FAILED":
            console.log(
              `Failed to install app version '${evt.version.hash}': ${evt.error}`
            );
            break;
        }
      });
    }
  }
  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
}
